import { useState } from 'react';
import { motion } from 'framer-motion';
import { PROJECTS } from './data';

export default function Work() {
  const sectors = ['All', ...new Set(PROJECTS.map(p => p.sector))];
  const [s, setS] = useState('All');
  const list = s === 'All' ? PROJECTS : PROJECTS.filter(p => p.sector === s);
  return (
    <div className="bg-[#F0EBE0] text-[#1B2D8C] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-[#1B2D8C]">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#1B2D8C]/65 mb-3">— § 02 / Work · 24 case studies, in order of completion</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">Twenty-four cases.</h1>
      </section>
      <div className="border-b border-[#1B2D8C]/15 sticky top-20 bg-[#F0EBE0]/95 backdrop-blur-md z-30">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-4 flex flex-wrap gap-2 font-mono text-[10px] tracking-[0.22em] uppercase">
          {sectors.map(sec => (
            <button key={sec} onClick={() => setS(sec)} data-testid={`vsp-sec-${sec}`} className={`px-4 py-1.5 transition-colors ${s === sec ? 'bg-[#1B2D8C] text-[#FFC700]' : 'border border-[#1B2D8C]/25 text-[#1B2D8C]/65 hover:border-[#1B2D8C]'}`}>{sec}</button>
          ))}
        </div>
      </div>
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-12 space-y-3">
        {list.map((p, i) => (
          <motion.article key={p.code} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: i * 0.04 }} className="grid grid-cols-1 lg:grid-cols-[80px_140px_1fr_120px_100px_120px_100px] gap-4 lg:gap-6 items-center bg-white border border-[#1B2D8C]/15 hover:border-[#1B2D8C] p-4 transition-colors">
            <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#FFC700] bg-[#1B2D8C] inline-block px-2 py-0.5 w-fit">{p.code}</p>
            <p className="font-serif italic text-lg">{p.client}</p>
            <p className="font-sans text-sm text-[#1B2D8C]/85" dangerouslySetInnerHTML={{ __html: p.t }} />
            <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#1B2D8C]/65">{p.sector}</p>
            <p className="font-serif text-lg">{p.year}</p>
            <p className="font-mono text-xs">{p.months} months</p>
            <button data-testid={`vsp-row-${p.code}`} className="font-mono text-[10px] tracking-[0.3em] uppercase border border-[#1B2D8C]/30 px-3 py-2 hover:bg-[#1B2D8C] hover:text-[#FFC700] transition-colors">Case →</button>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
